import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { Button } from 'ui-components/components/button';
import { FormattedMessage } from 'react-intl';
import { Modal } from 'ui-components/components/modal';
import { ModalHeader } from 'ui-components/components/modal/modal-header';
import { ModalBody } from 'ui-components/components/modal/modal-body';
import { ModalFooter } from 'ui-components/components/modal/modal-footer';
import { ProductDetailsContext } from '../../../context';
import style from './style.module.css';

export const DeletionWarningModal = ({ aliasSku, aliasStore, onConfirmDeletion, onCloseModal }) => {
  const { productSku } = useContext(ProductDetailsContext);

  return (
    <Modal className={style['add-tag-modal']}>
      <ModalHeader closeModal={onCloseModal}>
        <FormattedMessage defaultMessage='Confirm Delete' description='Alias Deletion Modal title' id='ZsuApn' />
      </ModalHeader>
      <ModalBody className={style['modal-body']}>
        <div className={style['bottom-padded']}>
          <FormattedMessage defaultMessage='Please note the following:' description='Alias Deletion Modal please Note' id='MMmLmZ' />
        </div>
        <div className={style['small-bottom-padded']}>
          <FormattedMessage
            defaultMessage='- Prior sales history will remain with SKU: {parentSku}.'
            description='Alias Deletion Modal sku Note'
            id='1gAl46'
            values={{ parentSku: productSku }}
          />
        </div>
        <div className={style['bottom-padded']}>
          <FormattedMessage
            defaultMessage='- Future orders for {sku} from {store} can create a new product record.'
            description='Alias Deletion Modal store Note'
            id='st2Ty5'
            values={{ sku: aliasSku, store: aliasStore }}
          />
        </div>
        <div>
          <FormattedMessage defaultMessage='Click "Confirm" to continue.' description='Alias Deletion Modal confirm Note' id='ce6r/v' />
        </div>
      </ModalBody>
      <ModalFooter className={style['modal-footer']}>
        <Button onClick={onCloseModal} theme='tertiary'>
          <FormattedMessage defaultMessage='Cancel' description='Alias Deletion Modal cancel' id='j/CBHU' />
        </Button>
        <Button onClick={onConfirmDeletion} theme='primary'>
          <FormattedMessage defaultMessage='Confirm' description='Alias Deletion Modal confirm' id='L77q+b' />
        </Button>
      </ModalFooter>
    </Modal>
  );
};

DeletionWarningModal.propTypes = {
  aliasSku: PropTypes.string.isRequired,
  aliasStore: PropTypes.string.isRequired,
  onConfirmDeletion: PropTypes.func.isRequired,
  onCloseModal: PropTypes.func.isRequired,
};
